import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./MovementItem.css";

function typeToFriendly(val) {
  switch(val) {
    case "AddedNewStock": 
    case "AddedStock": 
      return "Added";

    case "RemovedStock":
      return "Removed";

    case "MergedStock":
      return "Merged";

    default:
      return val;
  }
}

function signNumber(movementType, val) {
  if (movementType === "RemovedStock") {
    return `-${val}`;
  }
  return val;
}

function shortenDate(val) {
  return val.substring(0, 10);
}

const MovementItem = (props) => {

  let {data} = props;
  let classes = cx({
    "item": true,
    "inventory-movement-list-item": true,
    "u-hilight": data.get("movementType") === "RemovedStock"
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-sku f-nowrap">{data.get("warehouseId")}</td>
      <td className="field f-action">{typeToFriendly(data.get("movementType"))}</td>
      <td className="field f-quantity">{signNumber(data.get("movementType"), data.get("quantity"))}</td>
      <td className="field f-sku">{data.get("sku")}</td>
      <td className="field">{data.get("reason")}</td>
      <td className="field f-nowrap" title={data.get("occuredAt")}>{shortenDate(data.get("occuredAt"))}</td>
    </tr>
  )
}

export default MovementItem;